const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : process.env.REACT_APP_API_URL;
export default BASE_URL;
